import styled from 'styled-components'
import { device } from '@/common/constants/device'
import { useBodyScrollDisable, useOutsideClick } from '@/hooks'
import { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import {
  CreativesOverlay,
  hideTablet,
} from '@/components/Creatives/CreativesStyled'
import useIsVisible from '@/hooks/useIsVisible'
import { useSelector } from 'react-redux'

const BaseModalContent = styled.div`
  display: flex;
  flex-direction: column;
  background-color: var(--white);
  height: 100vh;
  margin-left: auto;
  width: 100%;

  @media ${device.tablet} {
    width: 445px;
  }
`

const BaseModal = styled(CreativesOverlay)`
  &.open {
    opacity: 1;
  }

  &.animation {
    animation: fadeOut 0.3s linear;

    ${BaseModalContent} {
      animation: fadeInRight 0.3s ease-in-out;
    }
  }

  &.open.animation {
    animation: fadeIn 0.3s linear forwards;

    ${BaseModalContent} {
      animation: fadeInLeft 0.3s ease-in-out forwards;
    }
  }

  &.hide {
    ${hideTablet};
  }
`

const CreativesBaseModal = ({
  onClose,
  Component,
  isAnimated,
  className = '',
  isShowScrollAfterDestroy = true,
  ...props
}) => {
  const modalRef = useRef(null)
  const [isMounted, setMounted] = useState(true)
  const { notificationIsVisible } = useSelector((state) => state.notifications)

  const modalWrapperRef = useRef(null)

  const creativesBaseModalClasses = classNames({
    open: isMounted,
    animation: isAnimated,
  })

  const closeModal = () => {
    if (!isMounted) {
      onClose()
    }
  }

  useBodyScrollDisable(isShowScrollAfterDestroy)

  const isVisible = useIsVisible(modalWrapperRef)
  useOutsideClick(() => {
    if (isVisible && !notificationIsVisible) {
      setMounted(false)
    }
  }, modalRef)

  useEffect(() => {
    if (!isMounted && !isAnimated) {
      onClose()
    }
  }, [isMounted])

  return (
    <BaseModal
      ref={modalWrapperRef}
      className={`${creativesBaseModalClasses} ${className}`}
      onAnimationEnd={closeModal}
    >
      <BaseModalContent ref={modalRef}>
        <Component onClose={onClose} {...props} />
      </BaseModalContent>
    </BaseModal>
  )
}

export default CreativesBaseModal
